var angular = require("angular");
var utils = require("./utils");
var types = utils.types;
var matches = utils.matches;
var Geo = require('../../geo');
var Category = require('../../category');
var _ = require("underscore");

angular.module("app.directives").directive('myEnter', function () {
  return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
          if(event.which === 13) {
              scope.$apply(function (){
                  scope.$eval(attrs.myEnter);
              });

              event.preventDefault();
          }
      });
  };
});

angular.module("app.directives").directive("questionInput", function () {
  return {
    template: require("./input.pug"),
    scope: {
      question: "="
    },
    link: function (scope, el, attrs) {
      if (!scope.value) scope.value = {};
      var $type = scope.question.$type;
      var type = scope.question.type = types[$type];
      var question = scope.question;

      if (type == "Document Upload" && question.fileName) {
        question.document = {
          "id": question.documentId,
          "fileName": question.fileName,
          "fileSize": question.fileSize
        };
      }

      scope.onChange = function () {
        scope.$emit("question-change", scope.question);
        scope.$emit("question-change-" + scope.question.id, scope.question);
      }

      scope.$watch("question.document", function (doc) {
        if (doc) {
          scope.question.fileSize = doc.fileSize;
          scope.question.fileName = doc.fileName;
          scope.question.documentId = doc.id;
        }
      }, true);
    },
    controller: function ($scope, ngDialog) {
      var vm = this;

      vm.calculatedTotal = 0;

      $scope.toggleMultipleChoice = function($event){
        $event.preventDefault();
        var model = $scope.question.answer;
        if (model && model.length) {
          $scope.question.answer = [];
          return
        }
        $scope.question.answer = angular.copy($scope.question.options)
      }

      vm.addGeo = function(e){
       e.preventDefault();
       var dialog = ngDialog.open(Geo.Dialog({value: $scope.question.selectedGeographicAreas}));

       dialog.closePromise.then(function(obj) {
         if (obj.value.action == "cancel") return;
         if (obj.value.action == "save") {
           var areas = obj.value.value || [];
           $scope.question.selectedGeographicAreas = areas.map(function(item) {
             item.name = item.displayName ? item.displayName : item.name;
             return item;
           });
         }
       })
     }

     vm.addCategory = function(e){
       e.preventDefault();
       var dialog = ngDialog.open(Category.Dialog({value: $scope.question.selectedCategories}));

       dialog.closePromise.then(function(obj) {
         if (obj.value.action == "cancel") return;
         if (obj.value.action == "save") {
           $scope.question.selectedCategories = obj.value.value;
         }
       })
     }

     vm.updateTotals = function(qdata){
       vm.calculatedTotal = 0;
        //lots of assumptions... 2 column table, with second column made up entirely of numbers
        if(qdata.length > 0){
          _.each(qdata, function (row) {
            vm.calculatedTotal += parseFloat(row[1]);
          });
        }
        else{
          qdata.push([]);
        }
     }
    },
    controllerAs: "vm"
  };
});
